<template>
  <div class="filters-wrapper">
    <div class="input-wrapper" :class="'input-wrapper-' + filter.value" v-for="(filter, index) in filters" :key="'filter' + index">
      <label :for="filter.key">{{filter.label}}</label>
      <template>
        <SelectCustom
          :isMultiple="isMultipleSelect(filter.value, 'multiple')"
          :isSearchable="isMultipleSelect(filter.value, 'searchable')"
          :options="getOptions(filter.options)"
          :filterID="filter.value"
          :translations="searchData.filter"
          :getActiveFilter="getSelectedOptions(filter.value, filter.options)"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SelectCustom from '@/components/SelectCustom.vue'

export default {
  name: 'filters',
  props: ['filters'],
  components: {
    SelectCustom
  },
  computed: {
    ...mapGetters([
      'searchData',
      'activeFilters'
    ])
  },
  methods: {
    isMultipleSelect (id, type) {
      let retVal = (type === 'multiple' ? 'multiple' : true)
      switch (id) {
        case 'productionDateFrom':
        case 'productionDateTo':
          retVal = (type === 'multiple' ? null : false)
          break
      }
      return retVal
    },
    getOptions (arr) {
      let retArr = []

      if (arr && arr.length) {
        arr.forEach((item) => {
          if (item.label && item.value) {
            retArr.push({
              label: item.label,
              value: encodeURIComponent(item.value)
            })
          }
        })
      }
      return retArr
    },
    getSelectedOptions (id, options) {
      let retArr = []
      if (!id || !this.activeFilters) { return }
      if (this.activeFilters[id] && this.activeFilters[id].length) {
        this.activeFilters[id].forEach((item) => {
          if (item[0] && this.hasOption(item[0], options)) {
            retArr.push({
              label: (item[1] ? item[1] : item[0]),
              value: encodeURIComponent(item[0])
            })
          }
        })
        return retArr
      }
    },
    hasOption (val, arr) {
      return arr.find((item) => item.value === encodeURIComponent(val))
    }
  }
}
</script>

<style scoped lang="scss">
  .filters-wrapper {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    @include clearfix();
  }
  .input-wrapper {
    margin: $gap-md 0;
    width: 100%;

    @include screen('md'){
      padding: 0 $gap-md;
      width: percentage(1/3);

      &:nth-child(1){ order: 1; }
      &:nth-child(2){ order: 2; }
      &:nth-child(3){ order: 4; }
      &:nth-child(4){ order: 5; }
      &:nth-child(5){ order: 7; }
      &:nth-child(6){ order: 8; }
      &-productionDateFrom { order: 3; }
      &-productionDateTo { order: 6; }

    } // END @include screen('md');
  }
  label {
    display: block;
    margin: 0.5em 0;
    font: {
      size: $font-s;
      weight: 700;
    }
    text-transform: uppercase;

    .font-size-l & {
      font-size: $font-m;
    }

    @include screen('sm') {
      font-size: $font-m;

      .font-size-l & {
        font-size: ($font-m * 1.2);
      }
    }
  }
</style>
